import { useCompatRouter as useRouter } from "@/lib/compat-router/context";
import { NoSubscriptions } from "@/components/bnp-illustrations";
import { Button } from "@/components/bnp-ui";
import { useAuth } from "@/contexts/AuthContext";
import { buildSignInUrl } from "@/utils/helpers/authReturn";

const REQUEST_PROPERTY_PATH =
  "/user/dashboard/properties/my-projects?createRequest=true";

const NoPropertyFound = () => {
  const router = useRouter();
  const { is_logged_in, status } = useAuth();
  const isLoading = status === "idle" || status === "loading";

  const showCreateRequest = true;

  const handleRequestProperty = () => {
    if (is_logged_in) {
      router.push(REQUEST_PROPERTY_PATH);
    } else {
      router.push(buildSignInUrl(REQUEST_PROPERTY_PATH));
    }
  };

  return (
    <div className="w-full flex justify-center items-center px-4 py-8 mt-8 lg:mt-12">
      <div className="w-full max-w-lg bg-white border border-slate-100 rounded-2xl shadow-sm p-8 sm:p-10 flex flex-col items-center text-center gap-8">
        <div className="w-16 h-16 rounded-full bg-slate-50 flex items-center justify-center text-slate-400">
          <NoSubscriptions />
        </div>

        <div className="flex flex-col gap-3 max-w-md">
          <h3 className="text-slate-800 text-lg sm:text-xl font-semibold tracking-tight leading-snug">
            We didn&apos;t find any property that matches your search
          </h3>
          {showCreateRequest && (
            <p className="text-slate-500 text-sm sm:text-base leading-relaxed">
              Create a property request now and we&apos;ll update you as soon as
              a property matching your description becomes available.
            </p>
          )}
        </div>

        {showCreateRequest && (
          <Button
            className="bg-bnp-dark hover:opacity-90 transition-all text-white text-sm font-medium w-[157px] h-[45px] rounded-lg"
            onClick={handleRequestProperty}
            isLoading={isLoading}
          >
            Request Property
          </Button>
        )}
      </div>
    </div>
  );
};

export default NoPropertyFound;
